import React from "react";
import CategoryListings from "../../Components/Category/CategoryListings";
import CategoryBreadCrumb from "../../Components/Category/CategoryBreadCrumb";
import CategoryCard from "../../Components/Category/CategoryCard";

export default function CategoryListing() {
  return (
    <React.Fragment>
      <div className="page-content">
        <CategoryBreadCrumb />
        <CategoryCard />
        {/* <CategoryListings /> */}
      </div>
    </React.Fragment>
  );
}
